import http from "@/api";
export const getCasePageApi = (params: {
	showFlag: string;
  pageNum: number;
  pageSize: number;
}) => {
  return http.get("/public/case/list", params);
  //return http.get("/enterprise/getAll");
};
export const getCaseDetailApi = (id: number) => {
  return http.get("/public/case/" + id);
};
export const getResolutionListApi = () => {
  return http.get("/public/system/resolution/list");
};
